import { render } from "./capabilities.vue?vue&type=template&id=41074a0c&scoped=true"
import script from "./capabilities.vue?vue&type=script&lang=js"
export * from "./capabilities.vue?vue&type=script&lang=js"

import "./capabilities.vue?vue&type=style&index=0&id=41074a0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-41074a0c"

export default script